<script lang="ts" setup>
  import { Features } from '@shared/features';

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: String,
    content: String,
    headerType: String,
  });
</script>
<template>
  <SfSection v-if="Features.newsletter.isEnabled" :title="header" :headerType class="newsletter-block">
    <div class="newsletter-block__content">
      <div class="newsletter-block__text-wrapper">
        <QuillContent v-if="content" :content />
        <Newsletter />
      </div>
      <div class="newsletter-block__logo-wrapper">
        <SfLogo class="newsletter-block__logo" />
      </div>
    </div>
  </SfSection>
</template>
<style lang="scss" scoped>
  .newsletter-block {
    &__content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 2rem;
      align-items: start;
    }

    &__text-wrapper {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    &__logo-wrapper {
      display: grid;
      place-items: center;
      height: 100%;
    }

    &__logo {
      max-width: 40%;
      height: auto;
    }

    @media (max-width: 992px) {
      &__content {
        gap: 1rem;
        grid-template-columns: 1fr;
      }

      &__text-wrapper > :deep(.ql-editor) {
        padding: 0 0.625rem;
      }

      &__logo-wrapper {
        order: -1;
      }
    }

    @media (max-width: 576px) {
      &__logo {
        max-width: 50%;
      }
    }
  }
</style>
